<mat-toolbar mat-dialog-title class="primary-bg" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <span class="title">Dossier pédagogique — {{ eleve.nomReferent }}</span>
  <button class="close-dialog" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="dossier-content thin-scrollbar">

  @if(isLoading()) {
  <app-loader message="Chargement du dossier..." class="margin"></app-loader>
  } @else if(historique().length === 0) {
  <div class="empty-state">
    <mat-icon>school</mat-icon>
    <p>Aucun historique disponible.</p>
  </div>
  } @else {

  <div class="timeline">
    @for(annee of historique(); track annee.idAnneeScolaire; let last = $last) {

    <div class="timeline-entry">
      <div class="timeline-left">
        <div class="timeline-dot" [class.en-cours]="annee.enCours"></div>
        @if(!last) { <div class="timeline-line"></div> }
      </div>
      <div class="timeline-body">
        <div class="timeline-year-row">
          <app-icon type="do" icon="annee-scolaire" class="primary" />
          <span class="annee-label">{{ annee.anneeScolaire }}</span>
        </div>

        <mat-accordion multi class="inscriptions-accordion">
          @for(inscription of annee.inscriptions; track inscription.idInscriptionLasido) {

          @let evaluationsAvecCours = getEvaluationsAvecCours(inscription);
          @let nbCours = inscription.cours.length;
          @let nbEvals = evaluationsAvecCours.length;

          <mat-expansion-panel class="inscription-panel">
            <mat-expansion-panel-header class="inscription-panel-header">
              <mat-panel-title>
                <div class="inscription-title">
                  <span class="inscription-info-item">
                    <app-icon type="do" icon="etablissement" />
                    <span class="inscription-etablissement">{{ inscription.etablissement }}</span>
                  </span>
                  @if(inscription.accueil) {
                  <span class="inscription-info-separator">·</span>
                  <span class="inscription-info-item">
                    <app-icon type="do" icon="accueil" />
                    <span>{{ inscription.accueil }}</span>
                  </span>
                  }
                  <span class="inscription-dates">
                    <mat-icon class="meta-icon">event</mat-icon>
                    {{ inscription.dateDebut }} – {{ inscription.dateFin }}
                  </span>
                  @if(nbCours > 0) {
                  <span class="cours-count-chip inscription-cours-count">{{ nbCours }} cours</span>
                  } @else {
                  <span class="cours-count-chip muted inscription-cours-count">Aucun cours</span>
                  }
                  @if(nbEvals > 0) {
                  <span class="cours-count-chip inscription-cours-count">{{ nbEvals }} évaluation{{ nbEvals > 1 ? 's' :
                    '' }}</span>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @if(nbCours > 0) {

            <!-- Liste des cours -->
            <div class="cours-section-header">
              <app-icon type="do" icon="cours" />
              <span>Cours</span>
            </div>
            <div class="cours-list">
              @for(cours of inscription.cours; track cours.id) {
              <div class="cours-card" [style.border-left-color]="cours.couleurDiscipline">
                <div class="cours-header">
                  <div class="cours-badges">
                    <span class="cours-libelle-badge">{{ cours.libelle }}</span>
                    <span class="discipline-badge" [style.color]="cours.couleurDiscipline"
                      [style.border-color]="cours.couleurDiscipline + '66'">
                      <app-icon size="20" type="do" icon="discipline" style="margin-right: 3px;margin-top: -1px"
                        title="Discipline" />
                      {{ cours.discipline }}
                    </span>
                    <span class="niveau-badge">{{ cours.niveau }}</span>
                    <span class="type-badge">
                      <mat-icon class="type-icon">{{ cours.individuel ? 'person' : 'group' }}</mat-icon>
                      {{ cours.individuel ? 'Individuel' : 'Collectif' }}
                    </span>
                    @if(cours.arret) {
                    <span class="arret-badge">
                      <mat-icon class="type-icon">block</mat-icon>Arrêté
                    </span>
                    }
                  </div>
                  <div class="cours-meta">
                    @if(cours.departement) {
                    <span class="meta-item">
                      <app-icon icon="departement" type="do" class="meta-icon" size="18" title="Département" />
                      {{ cours.departement }}
                    </span>
                    }

                    <span class="meta-item">
                      <mat-icon class="meta-icon" title="Horaires" title="Jour">event</mat-icon>
                      {{ cours.jour || 'Non défini' }}
                    </span>

                    <span class="meta-item">
                      <mat-icon class="meta-icon" title="Horaires">schedule</mat-icon>
                      {{ cours.heureDebut }} – {{ cours.heureFin }}
                    </span>
                    @if(cours.enseignants.length > 0) {
                    <span class="meta-item">
                      <app-icon icon="enseignant" type="do" class="meta-icon" size="18" title="Enseignant" />
                      {{ cours.enseignants.join(', ') }}
                    </span>

                    @if(cours.salle) {
                    <span class="meta-item">
                      <app-icon icon="salle" type="do" class="meta-icon" size="18" title="Salle" />
                      {{ cours.salle }}
                    </span>}
                    }
                  </div>
                </div>
              </div>
              }
            </div>

            <!-- Section évaluations dédupliquées -->
            @if(evaluationsAvecCours.length > 0) {
            <div class="evaluations-section">
              <div class="evaluations-section-header">
                <app-icon type="do" icon="evaluation" />
                <span>Évaluations</span>
              </div>
              <mat-accordion displayMode="flat" class="eval-accordion">
                @for(evalAvecCours of evaluationsAvecCours; track evalAvecCours.evalItem.evaluation.idEvaluation) {
                <mat-expansion-panel class="eval-panel">
                  <mat-expansion-panel-header class="eval-panel-header">
                    <mat-panel-title>
                      <div class="eval-header-layout">
                        <div class="eval-header-top">
                          <div class="panel-chip" [class.panel-chip-primary]="!evalAvecCours.evalItem.examen"
                            [class.panel-chip-accent]="evalAvecCours.evalItem.examen">
                            <app-icon size="18" type="do"
                              [icon]="evalAvecCours.evalItem.examen ? 'examen' : 'evaluation'" />
                            N°{{ evalAvecCours.evalItem.evaluation.numEvaluation }}
                          </div>

                          <div class="panel-chip">
                            @if(evalAvecCours.evalItem.examen) {
                            <mat-icon class="reussite-icon"
                              [style.color]="evalAvecCours.evalItem.reussiteExamen ? '#6EBF6D' : '#DA5255'"
                              [matTooltip]="evalAvecCours.evalItem.reussiteExamen ? 'Réussite' : 'Échec'">
                              {{ evalAvecCours.evalItem.reussiteExamen ? 'check_circle' : 'cancel' }}
                            </mat-icon>
                            }
                            {{ evalAvecCours.evalItem.evaluation._libelle }}
                          </div>
                          <div class="panel-chip">
                            @if (evalAvecCours.evalItem.evaluation.dateDebut ===
                            evalAvecCours.evalItem.evaluation.dateFin) {
                            {{evalAvecCours.evalItem.evaluation.dateDebut | date:'shortDate'}}
                            }@else{
                            Du {{evalAvecCours.evalItem.evaluation.dateDebut | date:'shortDate'}} au
                            {{evalAvecCours.evalItem.evaluation.dateFin | date:'shortDate'}}
                            }
                          </div>
                          @if(evalAvecCours.evalItem.evaluation.idCours !== 0) {
                          @if(evalAvecCours.coursAssocie; as cours) {
                          <div class="panel-chip" [style.color]="cours.couleurDiscipline"
                            [style.border-color]="cours.couleurDiscipline + '66'">
                            <mat-icon class="type-icon">music_note</mat-icon>
                            {{ cours.libelle }}
                          </div>
                          }
                          } @else {
                          @for(disc of evalAvecCours.uniqueDisciplines; track disc.discipline) {
                          <div class="panel-chip" [style.color]="disc.couleurDiscipline"
                            [style.border-color]="disc.couleurDiscipline + '66'">
                            {{ disc.discipline }}
                          </div>
                          }
                          }
                        </div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <!-- Corps de l'évaluation -->
                  @let criteresData = buildCriteresData(evalAvecCours.evalItem);

                  @if(evalAvecCours.evalItem.appreciation) {
                  <mat-card appearance="outlined" class="evaluation-card" style="margin-bottom: 6px;">
                    <label class="evaluation-label">Appréciation</label>
                    <mat-card-content class="evaluation-content">
                      <span class="texte-compact">{{ formatText(evalAvecCours.evalItem.appreciation) }}</span>
                    </mat-card-content>
                  </mat-card>
                  } @else {
                  <p class="no-appreciation">Aucune appréciation saisie.</p>
                  }

                  @if(evalAvecCours.evalItem.criteresNotation?.length) {
                  <mat-card appearance="outlined" class="evaluation-card" style="margin-bottom: 6px;">
                    <mat-card-content class="evaluation-content" style="padding: 0;">
                      @if(config?.sortedByCode) {
                      @for(group of groupCriteresByCode(evalAvecCours.evalItem.criteresNotation); track group.code) {
                      <div class="critere-group">
                        @if(group.code) {
                        <div class="critere-group-header">{{group.code}}</div>
                        }
                        <div class="criteres-compact-list">
                          @for(critere of group.criteres; track $index) {
                          <ng-container
                            *ngTemplateOutlet="critereInfoCompact; context: { critere: critere, criteresData: criteresData }"></ng-container>
                          }
                        </div>
                      </div>
                      }
                      } @else {
                      <div class="criteres-compact-list">
                        @for(critere of evalAvecCours.evalItem.criteresNotation; track $index) {
                        <ng-container
                          *ngTemplateOutlet="critereInfoCompact; context: { critere: critere, criteresData: criteresData }"></ng-container>
                        }
                      </div>
                      }
                    </mat-card-content>
                  </mat-card>
                  @let synthese = getSyntheseStatsForEval(evalAvecCours.evalItem.criteresNotation, criteresData);
                  @if(synthese) {
                  <mat-card appearance="outlined" class="evaluation-card">
                    <label class="evaluation-label fx-direction-row fx-start-center">
                      <mat-icon style="font-size:16px;height:16px;width:16px;margin-right:4px">summarize</mat-icon>
                      Synthèse de l'évaluation
                    </label>
                    <mat-card-content class="evaluation-content" style="padding-bottom: 0;">
                      <ng-container *ngTemplateOutlet="syntheseTable; context: { stats: synthese }"></ng-container>
                    </mat-card-content>
                  </mat-card>
                  }
                  }
                </mat-expansion-panel>
                }
              </mat-accordion>
            </div>
            }

            } @else {
            <p class="no-cours-msg">Aucun cours pour ce dossier d'inscription.</p>
            }

          </mat-expansion-panel>
          }
        </mat-accordion>

      </div><!-- timeline-body -->
    </div><!-- timeline-entry -->
    }
  </div><!-- timeline -->

  }

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Fermer</button>
</mat-dialog-actions>

<ng-template #critereInfoCompact let-critere="critere" let-criteresData="criteresData">
  @let value = criteresData[critere.id];
  @let status = getCritereStatus(critere, criteresData);
  <div class="critere-compact-row">
    @if(status !== null) {
    <span class="critere-status" [class.status-reussi]="status" [class.status-echec]="!status"></span>
    }
    <span class="evaluation-label fx-direction-row fx-start-center">
      @if(critere.obligatoire) {
      <mat-icon color="warn" class="obligatoire-icon" matTooltip="Obligatoire">error</mat-icon>
      }
      {{ critere.critere }}
    </span>
    <span class="critere-compact-value">
      @switch (critere.type) {
      @case ('numerique') {
      <span class="note-compact">{{ value ?? 0 }}</span>
      }
      @case ('checkbox') {
      <mat-icon [style.color]="value ? '#6EBF6D' : '#DA5255'" style="font-size: 24px; height: 24px; width: 24px;">
        {{ value ? 'check_circle' : 'cancel' }}
      </mat-icon>
      }
      @case ('liste') {
      @for(v of critere.valeurs; track v) {
      @if(v.id === value) { {{ v.libelle }} }
      }
      }
      @case ('texte') {
      <span class="texte-compact">{{ value }}</span>
      }
      }
    </span>
  </div>
</ng-template>

<ng-template #syntheseTable let-stats="stats">
  <table class="synthese-table">
    <thead>
      <tr>
        <th></th>
        <th><mat-icon
            style="font-size:16px;height:16px;width:16px;color:#6EBF6D;vertical-align:middle">check_circle</mat-icon>
        </th>
        <th><mat-icon
            style="font-size:16px;height:16px;width:16px;color:#DA5255;vertical-align:middle">cancel</mat-icon></th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      @if(stats.obligatoires.total > 0) {
      <tr>
        <td class="synthese-label">
          <mat-icon color="warn"
            style="font-size:14px;height:14px;width:14px;vertical-align:middle;margin-right:4px;flex-shrink:0;">error</mat-icon>Obligatoires
        </td>
        <td class="synthese-reussi">{{stats.obligatoires.reussi}}</td>
        <td class="synthese-echec">{{stats.obligatoires.echec}}</td>
        <td class="synthese-total">{{stats.obligatoires.total}}</td>
      </tr>
      }
      @if(stats.nonObligatoires.total > 0) {
      <tr>
        <td class="synthese-label">Non obligatoires</td>
        <td class="synthese-reussi">{{stats.nonObligatoires.reussi}}</td>
        <td class="synthese-echec">{{stats.nonObligatoires.echec}}</td>
        <td class="synthese-total">{{stats.nonObligatoires.total}}</td>
      </tr>
      }
      <tr class="synthese-row-total">
        <td class="synthese-label">Tous</td>
        <td class="synthese-reussi">{{stats.tous.reussi}}</td>
        <td class="synthese-echec">{{stats.tous.echec}}</td>
        <td class="synthese-total">{{stats.tous.total}}</td>
      </tr>
    </tbody>
  </table>
</ng-template>
